import React, { useState } from 'react';
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { LoadingButton } from "@mui/lab";
import { Alert, Box } from "@mui/material";

export default function StripePaymentForm({ amount, onSubmit, isLoading }) {
    const stripe = useStripe();
    const elements = useElements();
    const [error, setError] = useState(null);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError(null);

        if (!stripe || !elements) return;

        // 1. Crear el PaymentMethod en Stripe (Frontend)
        const { error: stripeError, paymentMethod } = await stripe.createPaymentMethod({
            type: 'card',
            card: elements.getElement(CardElement),
        });

        if (stripeError) {
            setError(stripeError.message);
            return;
        }

        // 2. Enviar al Padre (PaymentContainer) para procesar en Backend
        // Enviamos el ID del método de pago generado
        onSubmit({
            payment_method_id: paymentMethod.id, 
            type: 'stripe'
        });
    };

    return (
        <form onSubmit={handleSubmit}>
            <Box sx={{ p: 2, border: '1px solid #e0e0e0', borderRadius: 1, mb: 2 }}>
                <CardElement options={{
                    style: {
                        base: { fontSize: '16px', color: '#424770', '::placeholder': { color: '#aab7c4' } },
                        invalid: { color: '#9e2146' },
                    },
                }}/>
            </Box>

            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

            <LoadingButton 
                type="submit" 
                variant="contained" 
                fullWidth 
                loading={isLoading}
                disabled={!stripe}
            >
                Pagar ${parseFloat(amount).toFixed(2)}
            </LoadingButton>
        </form>
    );
}